"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/generate-deployments/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllMarkets = void 0;
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable @typescript-eslint/no-unused-vars */
const basic_types_1 = require("./basic-types");
const ALL_MARKETS = [
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "United Arab Emirates",
            iso2: basic_types_1.IsoCountryCode2.AE,
            iso3: basic_types_1.IsoCountryCode3.ARE,
            latitude: 23.424076,
            longitude: 53.847818,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ar_ae,
            currency: {
                name: "Dirham",
                code: basic_types_1.CurrencyCode.AED,
                number: 784,
                symbol: "د.إ",
            },
            mdmCountryId: 2,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_ae,
                basic_types_1.Locale.en_ae,
            ],
            defaultLocale: basic_types_1.Locale.ar_ae,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "",
            dateFormat: {
                [basic_types_1.Locale.ar_ae]: "ar",
                [basic_types_1.Locale.en_ae]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Antarctica",
            iso2: basic_types_1.IsoCountryCode2.AQ,
            iso3: basic_types_1.IsoCountryCode3.ATA,
            latitude: -75.250973,
            longitude: 36.09127,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 212,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.es,
                basic_types_1.Language.fr,
                basic_types_1.Language.de,
                basic_types_1.Language.it,
                basic_types_1.Language.uk,
                basic_types_1.Language.th,
            ],
            locales: [
                basic_types_1.Locale.en_aq,
                basic_types_1.Locale.es_aq,
                basic_types_1.Locale.fr_aq,
                basic_types_1.Locale.de_aq,
                basic_types_1.Locale.it_aq,
                basic_types_1.Locale.uk_aq,
                basic_types_1.Locale.th_aq,
            ],
            defaultLocale: basic_types_1.Locale.en_aq,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en_aq]: "enUS",
                [basic_types_1.Locale.es_aq]: "es",
                [basic_types_1.Locale.fr_aq]: "fr",
                [basic_types_1.Locale.de_aq]: "de",
                [basic_types_1.Locale.it_aq]: "it",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_WEST_3,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Argentina",
            iso2: basic_types_1.IsoCountryCode2.AR,
            iso3: basic_types_1.IsoCountryCode3.ARG,
            latitude: -34.583333333333336,
            longitude: -58.666667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.es_ar,
            currency: {
                name: "Peso",
                code: basic_types_1.CurrencyCode.ARS,
                number: 32,
                symbol: "$",
            },
            mdmCountryId: 11,
            languages: [
                basic_types_1.Language.es,
                basic_types_1.Language.en,
                basic_types_1.Language.pt,
            ],
            locales: [
                basic_types_1.Locale.es_ar,
                basic_types_1.Locale.en_ar,
                basic_types_1.Locale.pt_ar,
            ],
            defaultLocale: basic_types_1.Locale.es_ar,
            defaultLanguage: basic_types_1.Language.es,
            zipCodeRegex: "^[A-Z]?\d{4}[A-Z]{0,3}$",
            dateFormat: {
                [basic_types_1.Locale.es_ar]: "es",
                [basic_types_1.Locale.en_ar]: "enUS",
                [basic_types_1.Locale.pt_ar]: "pt",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Austria",
            iso2: basic_types_1.IsoCountryCode2.AT,
            iso3: basic_types_1.IsoCountryCode3.AUT,
            latitude: 48.2,
            longitude: 16.366667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.de_at,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 13,
            languages: [
                basic_types_1.Language.de,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.de_at,
                basic_types_1.Locale.en_at,
            ],
            defaultLocale: basic_types_1.Locale.de_at,
            defaultLanguage: basic_types_1.Language.de,
            zipCodeRegex: "^\\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.de_at]: "de",
                [basic_types_1.Locale.en_at]: "enGB",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Australia",
            iso2: basic_types_1.IsoCountryCode2.AU,
            iso3: basic_types_1.IsoCountryCode3.AUS,
            latitude: -25.274398,
            longitude: 133.775136,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_gb,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.AUD,
                number: 36,
                symbol: "$",
            },
            mdmCountryId: 14,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_au,
            ],
            defaultLocale: basic_types_1.Locale.en_au,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.en_au]: "enAU",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Brazil",
            iso2: basic_types_1.IsoCountryCode2.BR,
            iso3: basic_types_1.IsoCountryCode3.BRA,
            latitude: -15.783333333333333,
            longitude: -47.916667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.pt_br,
            currency: {
                name: "Real",
                code: basic_types_1.CurrencyCode.BRL,
                number: 986,
                symbol: "R$",
            },
            mdmCountryId: 29,
            languages: [
                basic_types_1.Language.pt,
            ],
            locales: [
                basic_types_1.Locale.pt_br,
            ],
            defaultLocale: basic_types_1.Locale.pt_br,
            defaultLanguage: basic_types_1.Language.pt,
            zipCodeRegex: "^\d{5}-\d{3}$",
            dateFormat: {
                [basic_types_1.Locale.pt_br]: "ptBR",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 4 * * ? *)" } },
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Canada",
            iso2: basic_types_1.IsoCountryCode2.CA,
            iso3: basic_types_1.IsoCountryCode3.CAN,
            latitude: 45.416666666666664,
            longitude: -75.700000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.CAD,
                number: 124,
                symbol: "$",
            },
            mdmCountryId: 36,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.fr,
            ],
            locales: [
                basic_types_1.Locale.en_ca,
                basic_types_1.Locale.fr_ca,
            ],
            defaultLocale: basic_types_1.Locale.en_ca,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "",
            dateFormat: {
                [basic_types_1.Locale.en_ca]: "enUS",
                [basic_types_1.Locale.fr_ca]: "fr",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 10 * * ? *)" } },
            restaurant_schedule: { "prod": { "dataset": "prod_bk_ca", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_bk_ca", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_bk_ca", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_bk_ca", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Switzerland",
            iso2: basic_types_1.IsoCountryCode2.CH,
            iso3: basic_types_1.IsoCountryCode3.CHE,
            latitude: 46.916666666666664,
            longitude: 7.466667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.fr_ch,
            currency: {
                name: "Franc",
                code: basic_types_1.CurrencyCode.CHF,
                number: 756,
                symbol: "CHF",
            },
            mdmCountryId: 40,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.de,
                basic_types_1.Language.fr,
                basic_types_1.Language.it,
            ],
            locales: [
                basic_types_1.Locale.en_ch,
                basic_types_1.Locale.de_ch,
                basic_types_1.Locale.fr_ch,
                basic_types_1.Locale.it_ch,
            ],
            defaultLocale: basic_types_1.Locale.en_ch,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\\d{4}$|^\\d{4}-\\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.en_ch]: "frCH",
                [basic_types_1.Locale.de_ch]: "frCH",
                [basic_types_1.Locale.fr_ch]: "frCH",
                [basic_types_1.Locale.it_ch]: "frCH",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_bk_ch", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_bk_ch", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_bk_ch", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_bk_ch", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Chile",
            iso2: basic_types_1.IsoCountryCode2.CL,
            iso3: basic_types_1.IsoCountryCode3.CHL,
            latitude: -33.45,
            longitude: -70.666667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_cl,
            currency: {
                name: "Peso",
                code: basic_types_1.CurrencyCode.CLP,
                number: 152,
                symbol: "$",
            },
            mdmCountryId: 43,
            languages: [
                basic_types_1.Language.es,
                basic_types_1.Language.en,
                basic_types_1.Language.pt,
            ],
            locales: [
                basic_types_1.Locale.es_cl,
                basic_types_1.Locale.en_cl,
                basic_types_1.Locale.pt_cl,
            ],
            defaultLocale: basic_types_1.Locale.es_cl,
            defaultLanguage: basic_types_1.Language.es,
            zipCodeRegex: "^(\d{7})$",
            dateFormat: {
                [basic_types_1.Locale.es_cl]: "es",
                [basic_types_1.Locale.en_cl]: "enUS",
                [basic_types_1.Locale.pt_cl]: "pt",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Czech Republic",
            iso2: basic_types_1.IsoCountryCode2.CZ,
            iso3: basic_types_1.IsoCountryCode3.CZE,
            latitude: 50.083333333333336,
            longitude: 14.466667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.cs,
            currency: {
                name: "Koruna",
                code: basic_types_1.CurrencyCode.CZK,
                number: 203,
                symbol: "Kč",
            },
            mdmCountryId: 52,
            languages: [
                basic_types_1.Language.cs,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.cs_cz,
                basic_types_1.Locale.en_cz,
            ],
            defaultLocale: basic_types_1.Locale.cs_cz,
            defaultLanguage: basic_types_1.Language.cs,
            zipCodeRegex: "^\\d{3}[ ]?\\d{2}$",
            dateFormat: {
                [basic_types_1.Locale.cs_cz]: "cs",
                [basic_types_1.Locale.en_cz]: "cs",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Germany",
            iso2: basic_types_1.IsoCountryCode2.DE,
            iso3: basic_types_1.IsoCountryCode3.DEU,
            latitude: 52.516666666666666,
            longitude: 13.400000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.de,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 53,
            languages: [
                basic_types_1.Language.de,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.de_de,
                basic_types_1.Locale.en_de,
            ],
            defaultLocale: basic_types_1.Locale.de_de,
            defaultLanguage: basic_types_1.Language.de,
            zipCodeRegex: "^\\d{5}$",
            dateFormat: {
                [basic_types_1.Locale.de_de]: "de",
                [basic_types_1.Locale.en_de]: "de",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_bk_de", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_bk_de", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_bk_de", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_bk_de", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Dominican Republic",
            iso2: basic_types_1.IsoCountryCode2.DO,
            iso3: basic_types_1.IsoCountryCode3.DOM,
            latitude: 18.7357,
            longitude: 70.1627,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.es_do,
            currency: {
                name: "Dominican Peso",
                code: basic_types_1.CurrencyCode.DOP,
                number: 214,
                symbol: "RD$",
            },
            mdmCountryId: 57,
            languages: [
                basic_types_1.Language.es,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.es_do,
                basic_types_1.Locale.en_do,
            ],
            defaultLocale: basic_types_1.Locale.es_do,
            defaultLanguage: basic_types_1.Language.es,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.es_do]: "es",
                [basic_types_1.Locale.en_do]: "enUS",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 4 * * ? *)" } },
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Egypt",
            iso2: basic_types_1.IsoCountryCode2.EG,
            iso3: basic_types_1.IsoCountryCode3.EGY,
            latitude: 26.820553,
            longitude: 30.802498,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ar_eg,
            currency: {
                name: "Pound",
                code: basic_types_1.CurrencyCode.EGP,
                number: 818,
                symbol: "ج.م",
            },
            mdmCountryId: 61,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_eg,
                basic_types_1.Locale.en_eg,
            ],
            defaultLocale: basic_types_1.Locale.ar_eg,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "^\d{5}$",
            dateFormat: {
                [basic_types_1.Locale.ar_eg]: "arEG",
                [basic_types_1.Locale.en_eg]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Spain",
            iso2: basic_types_1.IsoCountryCode2.ES,
            iso3: basic_types_1.IsoCountryCode3.ESP,
            latitude: 40.4,
            longitude: -3.683333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.es_es,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 62,
            languages: [
                basic_types_1.Language.es,
                basic_types_1.Language.ca,
                basic_types_1.Language.gl,
                basic_types_1.Language.eu,
                basic_types_1.Language.en,
                basic_types_1.Language.pt,
            ],
            locales: [
                basic_types_1.Locale.es_es,
                basic_types_1.Locale.ca_es,
                basic_types_1.Locale.gl_es,
                basic_types_1.Locale.eu_es,
                basic_types_1.Locale.en_es,
                basic_types_1.Locale.pt_es,
            ],
            defaultLocale: basic_types_1.Locale.es_es,
            defaultLanguage: basic_types_1.Language.es,
            zipCodeRegex: "^\\d{5}$",
            dateFormat: {
                [basic_types_1.Locale.es_es]: "es",
                [basic_types_1.Locale.ca_es]: "ca",
                [basic_types_1.Locale.gl_es]: "gl",
                [basic_types_1.Locale.eu_es]: "es",
                [basic_types_1.Locale.en_es]: "es",
                [basic_types_1.Locale.pt_es]: "pt",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_WEST_3,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "United Kingdom",
            iso2: basic_types_1.IsoCountryCode2.GB,
            iso3: basic_types_1.IsoCountryCode3.GBR,
            latitude: 51.5,
            longitude: -0.083333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_gb,
            currency: {
                name: "Pound",
                code: basic_types_1.CurrencyCode.GBP,
                number: 826,
                symbol: "£",
            },
            mdmCountryId: 71,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_gb,
            ],
            defaultLocale: basic_types_1.Locale.en_gb,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^(GIR|[A-Z]\\d[A-Z\\d]??|[A-Z]{2}\\d[A-Z\\d]??)[ ]??(\\d[A-Z]{2})$",
            dateFormat: {
                [basic_types_1.Locale.en_gb]: "enGB",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 5 * * ? *)" } },
            restaurant_schedule: { "prod": { "dataset": "prod_bk_gb", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_bk_gb", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_bk_gb", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_bk_gb", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Ireland",
            iso2: basic_types_1.IsoCountryCode2.IE,
            iso3: basic_types_1.IsoCountryCode3.IRL,
            latitude: 53.41291,
            longitude: -8.24389,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_gb,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 93,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_ie,
            ],
            defaultLocale: basic_types_1.Locale.en_ie,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "",
            dateFormat: {
                [basic_types_1.Locale.en_ie]: "enIE",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Cayman Islands",
            iso2: basic_types_1.IsoCountryCode2.KY,
            iso3: basic_types_1.IsoCountryCode3.CYM,
            latitude: 19.3133,
            longitude: 81.2546,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_ky,
            currency: {
                name: "Cayman Islands Dollar",
                code: basic_types_1.CurrencyCode.KYD,
                number: 136,
                symbol: "$",
            },
            mdmCountryId: 113,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_ky,
            ],
            defaultLocale: basic_types_1.Locale.en_ky,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en_ky]: "enUS",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 4 * * ? *)" } },
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Morocco",
            iso2: basic_types_1.IsoCountryCode2.MA,
            iso3: basic_types_1.IsoCountryCode3.MAR,
            latitude: 31.791702,
            longitude: -7.09262,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ar_ma,
            currency: {
                name: "Dirham",
                code: basic_types_1.CurrencyCode.MAD,
                number: 504,
                symbol: ".د.م",
            },
            mdmCountryId: 126,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.fr,
            ],
            locales: [
                basic_types_1.Locale.ar_ma,
                basic_types_1.Locale.fr_ma,
            ],
            defaultLocale: basic_types_1.Locale.ar_ma,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "^\d{5}$",
            dateFormat: {
                [basic_types_1.Locale.ar_ma]: "arMA",
                [basic_types_1.Locale.fr_ma]: "fr",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Mauritius",
            iso2: basic_types_1.IsoCountryCode2.MU,
            iso3: basic_types_1.IsoCountryCode3.MUS,
            latitude: 20.3484,
            longitude: 57.5522,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_mu,
            currency: {
                name: "Mauritian rupee",
                code: basic_types_1.CurrencyCode.MUR,
                number: 480,
                symbol: "Rs",
            },
            mdmCountryId: 313,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_mu,
            ],
            defaultLocale: basic_types_1.Locale.en_mu,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en_mu]: "enUS",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 4 * * ? *)" } },
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Mexico",
            iso2: basic_types_1.IsoCountryCode2.MX,
            iso3: basic_types_1.IsoCountryCode3.MEX,
            latitude: 19.433333333333334,
            longitude: -99.133333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.es_mx,
            currency: {
                name: "Peso",
                code: basic_types_1.CurrencyCode.MXN,
                number: 484,
                symbol: "$",
            },
            mdmCountryId: 143,
            languages: [
                basic_types_1.Language.es,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.es_mx,
                basic_types_1.Locale.en_mx,
            ],
            defaultLocale: basic_types_1.Locale.es_mx,
            defaultLanguage: basic_types_1.Language.es,
            zipCodeRegex: "^(\\d{5})$",
            dateFormat: {
                [basic_types_1.Locale.es_mx]: "es",
                [basic_types_1.Locale.en_mx]: "enUS",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Malaysia",
            iso2: basic_types_1.IsoCountryCode2.MY,
            iso3: basic_types_1.IsoCountryCode3.MYS,
            latitude: 4.210484,
            longitude: 101.975766,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ms_my,
            currency: {
                name: "Ringgit",
                code: basic_types_1.CurrencyCode.MYR,
                number: 458,
                symbol: "RM",
            },
            mdmCountryId: 144,
            languages: [
                basic_types_1.Language.ms,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ms_my,
                basic_types_1.Locale.en_my,
            ],
            defaultLocale: basic_types_1.Locale.ms_my,
            defaultLanguage: basic_types_1.Language.ms,
            zipCodeRegex: "^\d{5}$",
            dateFormat: {
                [basic_types_1.Locale.ms_my]: "ms",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Netherlands",
            iso2: basic_types_1.IsoCountryCode2.NL,
            iso3: basic_types_1.IsoCountryCode3.NLD,
            latitude: 52.35,
            longitude: 4.916667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.nl_nl,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 152,
            languages: [
                basic_types_1.Language.nl,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.nl_nl,
                basic_types_1.Locale.en_nl,
            ],
            defaultLocale: basic_types_1.Locale.nl_nl,
            defaultLanguage: basic_types_1.Language.nl,
            zipCodeRegex: "^\\d{4}[ ]?[A-Z]{2}$",
            dateFormat: {
                [basic_types_1.Locale.nl_nl]: "nl",
                [basic_types_1.Locale.en_nl]: "enGB",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 4 * * ? *)" } },
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "New Zealand",
            iso2: basic_types_1.IsoCountryCode2.NZ,
            iso3: basic_types_1.IsoCountryCode3.NZL,
            latitude: -41.3,
            longitude: 174.783333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_nz,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.NZD,
                number: 554,
                symbol: "$",
            },
            mdmCountryId: 157,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_nz,
            ],
            defaultLocale: basic_types_1.Locale.en_nz,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.en_nz]: "enNZ",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 17 * * ? *)" } },
            restaurant_schedule: { "prod": { "dataset": "prod_bk_nz", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_bk_nz", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_bk_nz", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_bk_nz", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Oman",
            iso2: basic_types_1.IsoCountryCode2.OM,
            iso3: basic_types_1.IsoCountryCode3.OMN,
            latitude: 21.512583,
            longitude: 55.923255,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ar_om,
            currency: {
                name: "Riyal",
                code: basic_types_1.CurrencyCode.OMR,
                number: 512,
                symbol: "﷼",
            },
            mdmCountryId: 158,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_om,
                basic_types_1.Locale.en_om,
            ],
            defaultLocale: basic_types_1.Locale.ar_om,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "^\d{3}$",
            dateFormat: {
                [basic_types_1.Locale.ar_om]: "ar",
                [basic_types_1.Locale.en_om]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Philippines",
            iso2: basic_types_1.IsoCountryCode2.PH,
            iso3: basic_types_1.IsoCountryCode3.PHL,
            latitude: 12.879721,
            longitude: 121.774017,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.tl_ph,
            currency: {
                name: "Peso",
                code: basic_types_1.CurrencyCode.PHP,
                number: 608,
                symbol: "₱",
            },
            mdmCountryId: 163,
            languages: [
                basic_types_1.Language.tl,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.tl_ph,
                basic_types_1.Locale.en_ph,
            ],
            defaultLocale: basic_types_1.Locale.tl_ph,
            defaultLanguage: basic_types_1.Language.tl,
            zipCodeRegex: "^\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.tl_ph]: "enUS",
                [basic_types_1.Locale.en_ph]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Poland",
            iso2: basic_types_1.IsoCountryCode2.PL,
            iso3: basic_types_1.IsoCountryCode3.POL,
            latitude: 52.25,
            longitude: 21.000000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.pl,
            currency: {
                name: "Zloty",
                code: basic_types_1.CurrencyCode.PLN,
                number: 985,
                symbol: "zł",
            },
            mdmCountryId: 165,
            languages: [
                basic_types_1.Language.pl,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.pl_pl,
                basic_types_1.Locale.en_pl,
            ],
            defaultLocale: basic_types_1.Locale.pl_pl,
            defaultLanguage: basic_types_1.Language.pl,
            zipCodeRegex: "^\\d{2}-\\d{3}$",
            dateFormat: {
                [basic_types_1.Locale.pl_pl]: "pl",
                [basic_types_1.Locale.en_pl]: "pl",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Puerto Rico",
            iso2: basic_types_1.IsoCountryCode2.PR,
            iso3: basic_types_1.IsoCountryCode3.PRI,
            latitude: 18.466666666666665,
            longitude: -66.116667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_pr,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 167,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.es,
            ],
            locales: [
                basic_types_1.Locale.en_pr,
                basic_types_1.Locale.es_pr,
            ],
            defaultLocale: basic_types_1.Locale.en_pr,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^00[679]\d{2}(?:-\d{4})?$",
            dateFormat: {
                [basic_types_1.Locale.es_pr]: "es",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Portugal",
            iso2: basic_types_1.IsoCountryCode2.PT,
            iso3: basic_types_1.IsoCountryCode3.PRT,
            latitude: 38.71666666666667,
            longitude: -9.133333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.pt_pt,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 168,
            languages: [
                basic_types_1.Language.pt,
                basic_types_1.Language.en,
                basic_types_1.Language.es,
            ],
            locales: [
                basic_types_1.Locale.pt_pt,
                basic_types_1.Locale.en_pt,
                basic_types_1.Locale.es_pt,
            ],
            defaultLocale: basic_types_1.Locale.pt_pt,
            defaultLanguage: basic_types_1.Language.pt,
            zipCodeRegex: "^\\d{4}([\-]\\d{3})?$",
            dateFormat: {
                [basic_types_1.Locale.pt_pt]: "pt",
                [basic_types_1.Locale.en_pt]: "pt",
                [basic_types_1.Locale.es_pt]: "pt",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_WEST_3,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Romania",
            iso2: basic_types_1.IsoCountryCode2.RO,
            iso3: basic_types_1.IsoCountryCode3.ROU,
            latitude: 44.43333333333333,
            longitude: 26.100000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ro,
            currency: {
                name: "Leu",
                code: basic_types_1.CurrencyCode.RON,
                number: 946,
                symbol: "lei",
            },
            mdmCountryId: 173,
            languages: [
                basic_types_1.Language.ro,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ro_ro,
                basic_types_1.Locale.en_ro,
            ],
            defaultLocale: basic_types_1.Locale.ro_ro,
            defaultLanguage: basic_types_1.Language.ro,
            zipCodeRegex: "^\\d{6}$",
            dateFormat: {
                [basic_types_1.Locale.ro_ro]: "ro",
                [basic_types_1.Locale.en_ro]: "enGB",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "Saudi Arabia",
            iso2: basic_types_1.IsoCountryCode2.SA,
            iso3: basic_types_1.IsoCountryCode3.SAU,
            latitude: 23.885942,
            longitude: 45.079162,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_sa,
            currency: {
                name: "Riyal",
                code: basic_types_1.CurrencyCode.SAR,
                number: 682,
                symbol: "SAR",
            },
            mdmCountryId: 176,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_sa,
                basic_types_1.Locale.en_sa,
            ],
            defaultLocale: basic_types_1.Locale.ar_sa,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "",
            dateFormat: {
                [basic_types_1.Locale.ar_sa]: "arSA",
                [basic_types_1.Locale.en_sa]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "United States",
            iso2: basic_types_1.IsoCountryCode2.US,
            iso3: basic_types_1.IsoCountryCode3.USA,
            latitude: 38.883333,
            longitude: -77.000000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 212,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en,
                basic_types_1.Locale.en_us,
            ],
            defaultLocale: basic_types_1.Locale.en,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en]: "enUS",
                [basic_types_1.Locale.en_us]: "enUS",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_bk_us", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_bk_us", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_bk_us", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_bk_us", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.BK,
        country: {
            name: "South Africa",
            iso2: basic_types_1.IsoCountryCode2.ZA,
            iso3: basic_types_1.IsoCountryCode3.ZAF,
            latitude: -25.7,
            longitude: 28.216667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_za,
            currency: {
                name: "Rand",
                code: basic_types_1.CurrencyCode.ZAR,
                number: 710,
                symbol: "R",
            },
            mdmCountryId: 228,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_za,
            ],
            defaultLocale: basic_types_1.Locale.en_za,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.en_za]: "enGB",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_bk_za", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_bk_za", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_bk_za", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_bk_za", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.FHS,
        country: {
            name: "United Arab Emirates",
            iso2: basic_types_1.IsoCountryCode2.AE,
            iso3: basic_types_1.IsoCountryCode3.ARE,
            latitude: 23.424076,
            longitude: 53.847818,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ar_ae,
            currency: {
                name: "Dirham",
                code: basic_types_1.CurrencyCode.AED,
                number: 784,
                symbol: "د.إ",
            },
            mdmCountryId: 2,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_ae,
                basic_types_1.Locale.en_ae,
            ],
            defaultLocale: basic_types_1.Locale.ar_ae,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "",
            dateFormat: {
                [basic_types_1.Locale.ar_ae]: "ar",
                [basic_types_1.Locale.en_ae]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.FHS,
        country: {
            name: "Antarctica",
            iso2: basic_types_1.IsoCountryCode2.AQ,
            iso3: basic_types_1.IsoCountryCode3.ATA,
            latitude: -75.250973,
            longitude: 36.09127,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 212,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.es,
                basic_types_1.Language.fr,
                basic_types_1.Language.de,
                basic_types_1.Language.it,
            ],
            locales: [
                basic_types_1.Locale.en_aq,
                basic_types_1.Locale.es_aq,
                basic_types_1.Locale.fr_aq,
                basic_types_1.Locale.de_aq,
                basic_types_1.Locale.it_aq,
            ],
            defaultLocale: basic_types_1.Locale.en_aq,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en_aq]: "enUS",
                [basic_types_1.Locale.es_aq]: "es",
                [basic_types_1.Locale.fr_aq]: "fr",
                [basic_types_1.Locale.de_aq]: "de",
                [basic_types_1.Locale.it_aq]: "it",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.FHS,
        country: {
            name: "Switzerland",
            iso2: basic_types_1.IsoCountryCode2.CH,
            iso3: basic_types_1.IsoCountryCode3.CHE,
            latitude: 46.916666666666664,
            longitude: 7.466667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.fr_ch,
            currency: {
                name: "Franc",
                code: basic_types_1.CurrencyCode.CHF,
                number: 756,
                symbol: "CHF",
            },
            mdmCountryId: 40,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.de,
            ],
            locales: [
                basic_types_1.Locale.en_ch,
                basic_types_1.Locale.de_ch,
            ],
            defaultLocale: basic_types_1.Locale.en_ch,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\\d{4}$|^\\d{4}-\\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.en_ch]: "frCH",
                [basic_types_1.Locale.de_ch]: "frCH",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.FHS,
        country: {
            name: "United Kingdom",
            iso2: basic_types_1.IsoCountryCode2.GB,
            iso3: basic_types_1.IsoCountryCode3.GBR,
            latitude: 51.5,
            longitude: -0.083333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_gb,
            currency: {
                name: "Pound",
                code: basic_types_1.CurrencyCode.GBP,
                number: 826,
                symbol: "£",
            },
            mdmCountryId: 71,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_gb,
            ],
            defaultLocale: basic_types_1.Locale.en_gb,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^(GIR|[A-Z]\\d[A-Z\\d]??|[A-Z]{2}\\d[A-Z\\d]??)[ ]??(\\d[A-Z]{2})$",
            dateFormat: {
                [basic_types_1.Locale.en_gb]: "enGB",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 5 * * ? *)" } },
            restaurant_schedule: { "prod": { "dataset": "prod_bk_gb", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_bk_gb", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_bk_gb", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_bk_gb", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.FHS,
        country: {
            name: "Mexico",
            iso2: basic_types_1.IsoCountryCode2.MX,
            iso3: basic_types_1.IsoCountryCode3.MEX,
            latitude: 19.433333333333334,
            longitude: -99.133333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.es_mx,
            currency: {
                name: "Peso",
                code: basic_types_1.CurrencyCode.MXN,
                number: 484,
                symbol: "$",
            },
            mdmCountryId: 143,
            languages: [
                basic_types_1.Language.es,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.es_mx,
                basic_types_1.Locale.en_mx,
            ],
            defaultLocale: basic_types_1.Locale.es_mx,
            defaultLanguage: basic_types_1.Language.es,
            zipCodeRegex: "^(\d{5})$",
            dateFormat: {
                [basic_types_1.Locale.es_mx]: "es",
                [basic_types_1.Locale.en_mx]: "enUS",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 4 * * ? *)" } },
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.FHS,
        country: {
            name: "Singapore",
            iso2: basic_types_1.IsoCountryCode2.SG,
            iso3: basic_types_1.IsoCountryCode3.SGP,
            latitude: 1.352083,
            longitude: 103.819836,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.cmn,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.SGD,
                number: 702,
                symbol: "$",
            },
            mdmCountryId: 181,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.ms,
                basic_types_1.Language.ta,
                basic_types_1.Language.zh,
            ],
            locales: [
                basic_types_1.Locale.en_sg,
                basic_types_1.Locale.ms_sg,
                basic_types_1.Locale.ta_sg,
                basic_types_1.Locale.zh_sg,
            ],
            defaultLocale: basic_types_1.Locale.en_sg,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\\d{6}$",
            dateFormat: {
                [basic_types_1.Locale.en_sg]: "enGB",
                [basic_types_1.Locale.ms_sg]: "enGB",
                [basic_types_1.Locale.ta_sg]: "ta",
                [basic_types_1.Locale.zh_sg]: "zhCN",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.FHS,
        country: {
            name: "United States",
            iso2: basic_types_1.IsoCountryCode2.US,
            iso3: basic_types_1.IsoCountryCode3.USA,
            latitude: 38.883333,
            longitude: -77.000000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 212,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en,
                basic_types_1.Locale.en_us,
            ],
            defaultLocale: basic_types_1.Locale.en,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en]: "enUS",
                [basic_types_1.Locale.en_us]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Antarctica",
            iso2: basic_types_1.IsoCountryCode2.AQ,
            iso3: basic_types_1.IsoCountryCode3.ATA,
            latitude: -75.250973,
            longitude: 36.09127,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 212,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.es,
                basic_types_1.Language.fr,
                basic_types_1.Language.de,
                basic_types_1.Language.it,
            ],
            locales: [
                basic_types_1.Locale.en_aq,
                basic_types_1.Locale.es_aq,
                basic_types_1.Locale.fr_aq,
                basic_types_1.Locale.de_aq,
                basic_types_1.Locale.it_aq,
            ],
            defaultLocale: basic_types_1.Locale.en_aq,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en_aq]: "enUS",
                [basic_types_1.Locale.es_aq]: "es",
                [basic_types_1.Locale.fr_aq]: "fr",
                [basic_types_1.Locale.de_aq]: "de",
                [basic_types_1.Locale.it_aq]: "it",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Australia",
            iso2: basic_types_1.IsoCountryCode2.AU,
            iso3: basic_types_1.IsoCountryCode3.AUS,
            latitude: -25.274398,
            longitude: 133.775136,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_gb,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.AUD,
                number: 36,
                symbol: "$",
            },
            mdmCountryId: 14,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_au,
            ],
            defaultLocale: basic_types_1.Locale.en_au,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.en_au]: "enAU",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Bahrain",
            iso2: basic_types_1.IsoCountryCode2.BH,
            iso3: basic_types_1.IsoCountryCode3.BHR,
            latitude: 25.930414,
            longitude: 50.637772,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ar_bh,
            currency: {
                name: "Dinar",
                code: basic_types_1.CurrencyCode.BHD,
                number: 48,
                symbol: "",
            },
            mdmCountryId: 23,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_bh,
                basic_types_1.Locale.en_bh,
            ],
            defaultLocale: basic_types_1.Locale.ar_bh,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "",
            dateFormat: {
                [basic_types_1.Locale.ar_bh]: "ar",
                [basic_types_1.Locale.en_bh]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Brazil",
            iso2: basic_types_1.IsoCountryCode2.BR,
            iso3: basic_types_1.IsoCountryCode3.BRA,
            latitude: -15.783333333333333,
            longitude: -47.916667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.es_ar,
            currency: {
                name: "Real",
                code: basic_types_1.CurrencyCode.BRL,
                number: 986,
                symbol: "R$",
            },
            mdmCountryId: 29,
            languages: [
                basic_types_1.Language.pt,
            ],
            locales: [
                basic_types_1.Locale.pt_br,
            ],
            defaultLocale: basic_types_1.Locale.pt_br,
            defaultLanguage: basic_types_1.Language.pt,
            zipCodeRegex: "^\d{5}-\d{3}$",
            dateFormat: {
                [basic_types_1.Locale.pt_br]: "ptBR",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 4 * * ? *)" } },
            restaurant_schedule: {},
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_2,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Switzerland",
            iso2: basic_types_1.IsoCountryCode2.CH,
            iso3: basic_types_1.IsoCountryCode3.CHE,
            latitude: 46.916666666666664,
            longitude: 7.466667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.fr_ch,
            currency: {
                name: "Franc",
                code: basic_types_1.CurrencyCode.CHF,
                number: 756,
                symbol: "CHF",
            },
            mdmCountryId: 40,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.de,
            ],
            locales: [
                basic_types_1.Locale.en_ch,
                basic_types_1.Locale.de_ch,
            ],
            defaultLocale: basic_types_1.Locale.en_ch,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\\d{4}$|^\\d{4}-\\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.en_ch]: "frCH",
                [basic_types_1.Locale.de_ch]: "frCH",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_plk_ch", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_plk_ch", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_plk_ch", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_plk_ch", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Czech Republic",
            iso2: basic_types_1.IsoCountryCode2.CZ,
            iso3: basic_types_1.IsoCountryCode3.CZE,
            latitude: 50.083333333333336,
            longitude: 14.466667,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.cs,
            currency: {
                name: "Koruna",
                code: basic_types_1.CurrencyCode.CZK,
                number: 203,
                symbol: "Kč",
            },
            mdmCountryId: 52,
            languages: [
                basic_types_1.Language.cs,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.cs_cz,
                basic_types_1.Locale.en_cz,
            ],
            defaultLocale: basic_types_1.Locale.cs_cz,
            defaultLanguage: basic_types_1.Language.cs,
            zipCodeRegex: "^\\d{3}[ ]?\\d{2}$",
            dateFormat: {
                [basic_types_1.Locale.cs_cz]: "cs",
                [basic_types_1.Locale.en_cz]: "cs",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Spain",
            iso2: basic_types_1.IsoCountryCode2.ES,
            iso3: basic_types_1.IsoCountryCode3.ESP,
            latitude: 40.4,
            longitude: -3.683333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.es_es,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 62,
            languages: [
                basic_types_1.Language.es,
                basic_types_1.Language.ca,
                basic_types_1.Language.gl,
                basic_types_1.Language.eu,
                basic_types_1.Language.en,
                basic_types_1.Language.pt,
            ],
            locales: [
                basic_types_1.Locale.es_es,
                basic_types_1.Locale.ca_es,
                basic_types_1.Locale.gl_es,
                basic_types_1.Locale.eu_es,
                basic_types_1.Locale.en_es,
                basic_types_1.Locale.pt_es,
            ],
            defaultLocale: basic_types_1.Locale.es_es,
            defaultLanguage: basic_types_1.Language.es,
            zipCodeRegex: "^\\d{5}$",
            dateFormat: {
                [basic_types_1.Locale.es_es]: "es",
                [basic_types_1.Locale.ca_es]: "ca",
                [basic_types_1.Locale.gl_es]: "gl",
                [basic_types_1.Locale.eu_es]: "es",
                [basic_types_1.Locale.en_es]: "es",
                [basic_types_1.Locale.pt_es]: "es",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_plk_es", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_plk_es", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_plk_es", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_plk_es", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_WEST_3,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "France",
            iso2: basic_types_1.IsoCountryCode2.FR,
            iso3: basic_types_1.IsoCountryCode3.FRA,
            latitude: 48.86666666666667,
            longitude: 2.333333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.fr_fr,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 69,
            languages: [
                basic_types_1.Language.fr,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.fr_fr,
                basic_types_1.Locale.en_fr,
            ],
            defaultLocale: basic_types_1.Locale.fr_fr,
            defaultLanguage: basic_types_1.Language.fr,
            zipCodeRegex: "^\\d{2}[ ]?\\d{3}$",
            dateFormat: {
                [basic_types_1.Locale.fr_fr]: "fr",
                [basic_types_1.Locale.en_fr]: "fr",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_plk_fr", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_plk_fr", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_plk_fr", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_plk_fr", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Italy",
            iso2: basic_types_1.IsoCountryCode2.IT,
            iso3: basic_types_1.IsoCountryCode3.ITA,
            latitude: 45.4637,
            longitude: 9.1885,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.it_it,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 99,
            languages: [
                basic_types_1.Language.it,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.it_it,
                basic_types_1.Locale.en_it,
            ],
            defaultLocale: basic_types_1.Locale.it_it,
            defaultLanguage: basic_types_1.Language.it,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.it_it]: "it",
                [basic_types_1.Locale.en_it]: "it",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_plk_it", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_plk_it", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_plk_it", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_plk_it", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_WEST_3,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "South Korea",
            iso2: basic_types_1.IsoCountryCode2.KR,
            iso3: basic_types_1.IsoCountryCode3.KOR,
            latitude: 37.55,
            longitude: 126.983333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ko_kr,
            currency: {
                name: "Won",
                code: basic_types_1.CurrencyCode.KRW,
                number: 410,
                symbol: "₩",
            },
            mdmCountryId: 109,
            languages: [
                basic_types_1.Language.ko,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ko_kr,
                basic_types_1.Locale.en_kr,
            ],
            defaultLocale: basic_types_1.Locale.ko_kr,
            defaultLanguage: basic_types_1.Language.ko,
            zipCodeRegex: "^\\d{3}[\-]\\d{3}$",
            dateFormat: {
                [basic_types_1.Locale.ko_kr]: "ko",
                [basic_types_1.Locale.en_kr]: "ko",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_plk_kr", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_plk_kr", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_plk_kr", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_plk_kr", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Kuwait",
            iso2: basic_types_1.IsoCountryCode2.KW,
            iso3: basic_types_1.IsoCountryCode3.KWT,
            latitude: 29.31166,
            longitude: 47.481766,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ar_kw,
            currency: {
                name: "Dinar",
                code: basic_types_1.CurrencyCode.KWD,
                number: 414,
                symbol: "د.ك",
            },
            mdmCountryId: 112,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_kw,
                basic_types_1.Locale.en_kw,
            ],
            defaultLocale: basic_types_1.Locale.ar_kw,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "^\d{5}$",
            dateFormat: {
                [basic_types_1.Locale.ar_kw]: "ar",
                [basic_types_1.Locale.en_kw]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "New Zealand",
            iso2: basic_types_1.IsoCountryCode2.NZ,
            iso3: basic_types_1.IsoCountryCode3.NZL,
            latitude: -41.3,
            longitude: 174.783333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_nz,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.NZD,
                number: 554,
                symbol: "$",
            },
            mdmCountryId: 157,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en_nz,
            ],
            defaultLocale: basic_types_1.Locale.en_nz,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\\d{4}$",
            dateFormat: {
                [basic_types_1.Locale.en_nz]: "enNZ",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Poland",
            iso2: basic_types_1.IsoCountryCode2.PL,
            iso3: basic_types_1.IsoCountryCode3.POL,
            latitude: 52.25,
            longitude: 21.000000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.pl,
            currency: {
                name: "Zloty",
                code: basic_types_1.CurrencyCode.PLN,
                number: 985,
                symbol: "zł",
            },
            mdmCountryId: 165,
            languages: [
                basic_types_1.Language.pl,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.pl_pl,
                basic_types_1.Locale.en_pl,
            ],
            defaultLocale: basic_types_1.Locale.pl_pl,
            defaultLanguage: basic_types_1.Language.pl,
            zipCodeRegex: "^\\d{2}-\\d{3}$",
            dateFormat: {
                [basic_types_1.Locale.pl_pl]: "pl",
                [basic_types_1.Locale.en_pl]: "pl",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Portugal",
            iso2: basic_types_1.IsoCountryCode2.PT,
            iso3: basic_types_1.IsoCountryCode3.PRT,
            latitude: 38.71666666666667,
            longitude: -9.133333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.pt_pt,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 168,
            languages: [
                basic_types_1.Language.pt,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.pt_pt,
                basic_types_1.Locale.en_pt,
            ],
            defaultLocale: basic_types_1.Locale.pt_pt,
            defaultLanguage: basic_types_1.Language.pt,
            zipCodeRegex: "^\\d{4}([\-]\\d{3})?$",
            dateFormat: {
                [basic_types_1.Locale.pt_pt]: "pt",
                [basic_types_1.Locale.en_pt]: "pt",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_WEST_3,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Qatar",
            iso2: basic_types_1.IsoCountryCode2.QA,
            iso3: basic_types_1.IsoCountryCode3.QAT,
            latitude: 25.354826,
            longitude: 51.183884,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ar_qa,
            currency: {
                name: "Riyal",
                code: basic_types_1.CurrencyCode.QAR,
                number: 634,
                symbol: "ر.ق",
            },
            mdmCountryId: 171,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_qa,
                basic_types_1.Locale.en_qa,
            ],
            defaultLocale: basic_types_1.Locale.ar_qa,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "",
            dateFormat: {
                [basic_types_1.Locale.ar_qa]: "ar",
                [basic_types_1.Locale.en_qa]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Romania",
            iso2: basic_types_1.IsoCountryCode2.RO,
            iso3: basic_types_1.IsoCountryCode3.ROU,
            latitude: 44.43333333333333,
            longitude: 26.100000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ro,
            currency: {
                name: "Leu",
                code: basic_types_1.CurrencyCode.RON,
                number: 946,
                symbol: "lei",
            },
            mdmCountryId: 173,
            languages: [
                basic_types_1.Language.ro,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ro_ro,
                basic_types_1.Locale.en_ro,
            ],
            defaultLocale: basic_types_1.Locale.ro_ro,
            defaultLanguage: basic_types_1.Language.ro,
            zipCodeRegex: "^\\d{6}$",
            dateFormat: {
                [basic_types_1.Locale.ro_ro]: "ro",
                [basic_types_1.Locale.en_ro]: "enGB",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Saudi Arabia",
            iso2: basic_types_1.IsoCountryCode2.SA,
            iso3: basic_types_1.IsoCountryCode3.SAU,
            latitude: 23.885942,
            longitude: 45.079162,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_sa,
            currency: {
                name: "Riyal",
                code: basic_types_1.CurrencyCode.SAR,
                number: 682,
                symbol: "SAR",
            },
            mdmCountryId: 176,
            languages: [
                basic_types_1.Language.ar,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ar_sa,
                basic_types_1.Locale.en_sa,
            ],
            defaultLocale: basic_types_1.Locale.ar_sa,
            defaultLanguage: basic_types_1.Language.ar,
            zipCodeRegex: "^\d{5}(-{1}\d{4})?$",
            dateFormat: {
                [basic_types_1.Locale.ar_sa]: "arSA",
                [basic_types_1.Locale.en_sa]: "enUS",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Singapore",
            iso2: basic_types_1.IsoCountryCode2.SG,
            iso3: basic_types_1.IsoCountryCode3.SGP,
            latitude: 1.352083,
            longitude: 103.819836,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.cmn,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.SGD,
                number: 702,
                symbol: "$",
            },
            mdmCountryId: 181,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.ms,
                basic_types_1.Language.ta,
                basic_types_1.Language.zh,
            ],
            locales: [
                basic_types_1.Locale.en_sg,
                basic_types_1.Locale.ms_sg,
                basic_types_1.Locale.ta_sg,
                basic_types_1.Locale.zh_sg,
            ],
            defaultLocale: basic_types_1.Locale.en_sg,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^\\d{6}$",
            dateFormat: {
                [basic_types_1.Locale.en_sg]: "enGB",
                [basic_types_1.Locale.ms_sg]: "enGB",
                [basic_types_1.Locale.ta_sg]: "ta",
                [basic_types_1.Locale.zh_sg]: "zhCN",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "Taiwan",
            iso2: basic_types_1.IsoCountryCode2.TW,
            iso3: basic_types_1.IsoCountryCode3.TWN,
            latitude: 23.69781,
            longitude: 120.960515,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.zh_tw,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.TWD,
                number: 901,
                symbol: "元",
            },
            mdmCountryId: 206,
            languages: [
                basic_types_1.Language.zh,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.zh_tw,
                basic_types_1.Locale.en_tw,
            ],
            defaultLocale: basic_types_1.Locale.zh_tw,
            defaultLanguage: basic_types_1.Language.zh,
            zipCodeRegex: "^\\d{3}(\\d{2})?$",
            dateFormat: {
                [basic_types_1.Locale.zh_tw]: "zhTW",
                [basic_types_1.Locale.en_tw]: "enGB",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.PLK,
        country: {
            name: "United States",
            iso2: basic_types_1.IsoCountryCode2.US,
            iso3: basic_types_1.IsoCountryCode3.USA,
            latitude: 38.883333,
            longitude: -77.000000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 212,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en,
                basic_types_1.Locale.en_us,
            ],
            defaultLocale: basic_types_1.Locale.en,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en]: "enUS",
                [basic_types_1.Locale.en_us]: "enUS",
            },
        },
        mdm: {
            product_schedule: { "staging": { "rate": "cron(0 21 * * ? *)" } },
            restaurant_schedule: { "prod": { "dataset": "prod_plk_us", "rate": "cron(0/15 * * * ? *)" }, "qa": { "dataset": "qa_plk_us", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_plk_us", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_plk_us", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.TH,
        country: {
            name: "Antarctica",
            iso2: basic_types_1.IsoCountryCode2.AQ,
            iso3: basic_types_1.IsoCountryCode3.ATA,
            latitude: -75.250973,
            longitude: 36.09127,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 212,
            languages: [
                basic_types_1.Language.en,
                basic_types_1.Language.es,
                basic_types_1.Language.fr,
                basic_types_1.Language.de,
                basic_types_1.Language.it,
            ],
            locales: [
                basic_types_1.Locale.en_aq,
                basic_types_1.Locale.es_aq,
                basic_types_1.Locale.fr_aq,
                basic_types_1.Locale.de_aq,
                basic_types_1.Locale.it_aq,
            ],
            defaultLocale: basic_types_1.Locale.en_aq,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en_aq]: "enUS",
                [basic_types_1.Locale.es_aq]: "es",
                [basic_types_1.Locale.fr_aq]: "fr",
                [basic_types_1.Locale.de_aq]: "de",
                [basic_types_1.Locale.it_aq]: "it",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.TH,
        country: {
            name: "Spain",
            iso2: basic_types_1.IsoCountryCode2.ES,
            iso3: basic_types_1.IsoCountryCode3.ESP,
            latitude: 40.4,
            longitude: -3.683333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.es_es,
            currency: {
                name: "Euro",
                code: basic_types_1.CurrencyCode.EUR,
                number: 978,
                symbol: "€",
            },
            mdmCountryId: 62,
            languages: [
                basic_types_1.Language.es,
                basic_types_1.Language.ca,
                basic_types_1.Language.gl,
                basic_types_1.Language.eu,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.es_es,
                basic_types_1.Locale.ca_es,
                basic_types_1.Locale.gl_es,
                basic_types_1.Locale.eu_es,
                basic_types_1.Locale.en_es,
            ],
            defaultLocale: basic_types_1.Locale.es_es,
            defaultLanguage: basic_types_1.Language.es,
            zipCodeRegex: "^\\d{5}$",
            dateFormat: {
                [basic_types_1.Locale.es_es]: "es",
                [basic_types_1.Locale.ca_es]: "ca",
                [basic_types_1.Locale.gl_es]: "gl",
                [basic_types_1.Locale.eu_es]: "es",
                [basic_types_1.Locale.en_es]: "es",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.EU_CENTRAL_1,
        ],
    },
    {
        brand: basic_types_1.Brand.TH,
        country: {
            name: "South Korea",
            iso2: basic_types_1.IsoCountryCode2.KR,
            iso3: basic_types_1.IsoCountryCode3.KOR,
            latitude: 37.55,
            longitude: 126.983333,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.ko_kr,
            currency: {
                name: "Won",
                code: basic_types_1.CurrencyCode.KRW,
                number: 410,
                symbol: "₩",
            },
            mdmCountryId: 109,
            languages: [
                basic_types_1.Language.ko,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.ko_kr,
                basic_types_1.Locale.en_kr,
            ],
            defaultLocale: basic_types_1.Locale.ko_kr,
            defaultLanguage: basic_types_1.Language.ko,
            zipCodeRegex: "^\\d{3}[\-]\\d{3}$",
            dateFormat: {
                [basic_types_1.Locale.ko_kr]: "ko",
                [basic_types_1.Locale.en_kr]: "ko",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.TH,
        country: {
            name: "Taiwan",
            iso2: basic_types_1.IsoCountryCode2.TW,
            iso3: basic_types_1.IsoCountryCode3.TWN,
            latitude: 23.69781,
            longitude: 120.960515,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.zh_tw,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.TWD,
                number: 901,
                symbol: "元",
            },
            mdmCountryId: 206,
            languages: [
                basic_types_1.Language.zh,
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.zh_tw,
                basic_types_1.Locale.en_tw,
            ],
            defaultLocale: basic_types_1.Locale.zh_tw,
            defaultLanguage: basic_types_1.Language.zh,
            zipCodeRegex: "^\\d{3}(\\d{2})?$",
            dateFormat: {
                [basic_types_1.Locale.zh_tw]: "zhTW",
                [basic_types_1.Locale.en_tw]: "enGB",
            },
        },
        awsRegion: [
            basic_types_1.AwsRegion.AP_SOUTHEAST_1,
        ],
    },
    {
        brand: basic_types_1.Brand.TH,
        country: {
            name: "United States",
            iso2: basic_types_1.IsoCountryCode2.US,
            iso3: basic_types_1.IsoCountryCode3.USA,
            latitude: 38.883333,
            longitude: -77.000000,
            moneyFormatLocale: basic_types_1.MoneyFormatLocale.en_au,
            currency: {
                name: "Dollar",
                code: basic_types_1.CurrencyCode.USD,
                number: 840,
                symbol: "$",
            },
            mdmCountryId: 212,
            languages: [
                basic_types_1.Language.en,
            ],
            locales: [
                basic_types_1.Locale.en,
                basic_types_1.Locale.en_us,
            ],
            defaultLocale: basic_types_1.Locale.en,
            defaultLanguage: basic_types_1.Language.en,
            zipCodeRegex: "^([a-zA-Z0-9\\s_-]){4,10}$",
            dateFormat: {
                [basic_types_1.Locale.en]: "enUS",
                [basic_types_1.Locale.en_us]: "enUS",
            },
        },
        mdm: {
            product_schedule: {},
            restaurant_schedule: { "prod": { "dataset": "prod_th_us", "rate": "cron(15 * * * ? *)" }, "qa": { "dataset": "qa_th_us", "rate": "cron(0 0/4 * * ? *)" }, "staging": { "dataset": "staging_th_us", "rate": "cron(0 0/4 * * ? *)" }, "dev": { "dataset": "dev_th_us", "rate": "cron(0 0/4 * * ? *)" } },
        },
        awsRegion: [
            basic_types_1.AwsRegion.US_EAST_1,
        ],
    },
];
const getAllMarkets = () => {
    const allMarketsByBrand = {
        [basic_types_1.Brand.BK]: [],
        [basic_types_1.Brand.FHS]: [],
        [basic_types_1.Brand.PLK]: [],
        [basic_types_1.Brand.TH]: [],
    };
    Object.values(basic_types_1.Brand).forEach((brand) => {
        allMarketsByBrand[brand] = ALL_MARKETS.filter(m => m.brand === brand);
    });
    return allMarketsByBrand;
};
exports.getAllMarkets = getAllMarkets;
